import React from "react";

export const IconArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M8 11L14 17L20 11" stroke="#000000" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const EyeIcon = (props) => (
  <svg className={'cursor-pointer'} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
       fill="none" {...props}>
    <circle cx="12" cy="12" r="3" stroke="#33363F" strokeWidth="1.2" />
    <path
      d="M20.188 10.9343C20.5762 11.4056 20.7703 11.6412 20.7703 12C20.7703 12.3588 20.5762 12.5944 20.188 13.0657C18.7679 14.7899 15.6357 18 12 18C8.36427 18 5.23206 14.7899 3.81197 13.0657C3.42381 12.5944 3.22973 12.3588 3.22973 12C3.22973 11.6412 3.42381 11.4056 3.81197 10.9343C5.23206 9.21014 8.36427 6 12 6C15.6357 6 18.7679 9.21014 20.188 10.9343Z"
      stroke="#33363F"
      strokeWidth="1.2"
    />
  </svg>
);
export const EyeInvisibleIcon = (props) => (
  <svg className={'cursor-pointer'} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
       fill="none" {...props}>
    <circle cx="12" cy="12" r="3" stroke="#33363F" strokeWidth="1.2" />
    <path
      d="M20.188 10.9343C20.5762 11.4056 20.7703 11.6412 20.7703 12C20.7703 12.3588 20.5762 12.5944 20.188 13.0657C18.7679 14.7899 15.6357 18 12 18C8.36427 18 5.23206 14.7899 3.81197 13.0657C3.42381 12.5944 3.22973 12.3588 3.22973 12C3.22973 11.6412 3.42381 11.4056 3.81197 10.9343C5.23206 9.21014 8.36427 6 12 6C15.6357 6 18.7679 9.21014 20.188 10.9343Z"
      stroke="#33363F"
      strokeWidth="1.2"
    />
    <path d="M5 5L20 18" stroke="#ffffff" strokeWidth="4" />
    <path d="M5 1L22 18" stroke="#33363F" strokeWidth="1.2" />
  </svg>
);

export const ClearIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 31"
       fill="none">
    <path
      opacity="0.2"
      d="M28.8765 15.5028C28.8765 8.45785 23.1654 2.74679 16.1205 2.74679C9.07556 2.74679 3.3645 8.45785 3.3645 15.5028C3.3645 22.5477 9.07556 28.2588 16.1205 28.2588C23.1654 28.2588 28.8765 22.5477 28.8765 15.5028Z"
      fill="#737373"
    />
    <path
      d="M16.1206 14.1508L13.1867 11.2169C12.8168 10.847 12.2045 10.847 11.8346 11.2169C11.4646 11.5869 11.4646 12.1991 11.8346 12.5691L14.7685 15.5029L11.8346 18.4368C11.4646 18.8068 11.4646 19.419 11.8346 19.789C12.2045 20.1589 12.8168 20.1589 13.1867 19.789L16.1206 16.8551L19.0545 19.789C19.4244 20.1589 20.0367 20.1589 20.4066 19.789C20.5979 19.5976 20.6872 19.3553 20.6872 19.1129C20.6872 18.8705 20.5979 18.6282 20.4066 18.4368L17.4727 15.5029L20.4066 12.5691C20.5979 12.3777 20.6872 12.1354 20.6872 11.893C20.6872 11.6506 20.5979 11.4083 20.4066 11.2169C20.0367 10.847 19.4244 10.847 19.0545 11.2169L16.1206 14.1508Z"
      fill="#737373"
    />
  </svg>
);

export const CertificateIcon  = () => (
  <svg width="30px" height="30px" viewBox="-2.4 -2.4 28.80 28.80" fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g id="SVGRepo_iconCarrier">
      <path
        d="M9 10M12 3L13.9101 4.87147L16.5 4.20577L17.2184 6.78155L19.7942 7.5L19.1285 10.0899L21 12L19.1285 13.9101L19.7942 16.5L17.2184 17.2184L16.5 19.7942L13.9101 19.1285L12 21L10.0899 19.1285L7.5 19.7942L6.78155 17.2184L4.20577 16.5L4.87147 13.9101L3 12L4.87147 10.0899L4.20577 7.5L6.78155 6.78155L7.5 4.20577L10.0899 4.87147L12 3Z"
        fill="#93c5fd" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M7.5 11.5 L11.2 15.4 L15.5 8.7"
        stroke="#ffffff" strokeWidth="1.38" strokeLinecap="round" strokeLinejoin="round"
      />
    </g>
  </svg>
)
